import { NavLink } from "react-router-dom";
import css from "./DropdownLink.module.scss";
import colors from "../../styles/jscolors.module.scss"

export default function DropdownLink({ link, label, action, icon, color }) {
   return (
      <>
         {link ? (
            <NavLink to={link}>
               <div className={css["link"]} style={{color: colors[`${color}-600`]}}>
                  <span>{label}</span>
                  {icon ? <i className={`fad fa-${icon}`} /> : ""}
               </div>
            </NavLink>
         ) : (
            <button className={css["link"]} onClick={action} style={{color: colors[`${color}-600`]}}>
               <span>{label}</span>
               {icon ? <i className={`fad fa-${icon}`} /> : ""}
            </button>
         )}
      </>
   );
}
